import PropTypes from "prop-types";

import useReveal from "../../hooks/useReveal";

const Reveal = ({
  children,
  as,
  className,
  delayMs,
  threshold,
  rootMargin,
  triggerOnce,
}) => {
  const { elementRef, isVisible, reduceMotion } = useReveal({ threshold, rootMargin, triggerOnce });
  const Component = as;

  return (
    <Component
      ref={elementRef}
      className={`reveal ${isVisible ? "is-visible" : ""} ${className}`.trim()}
      style={reduceMotion ? undefined : { transitionDelay: `${delayMs}ms` }}
    >
      {children}
    </Component>
  );
};

Reveal.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.string,
  className: PropTypes.string,
  delayMs: PropTypes.number,
  threshold: PropTypes.number,
  rootMargin: PropTypes.string,
  triggerOnce: PropTypes.bool,
};

Reveal.defaultProps = {
  as: "div",
  className: "",
  delayMs: 0,
  threshold: 0.2,
  rootMargin: "0px",
  triggerOnce: true,
};

export default Reveal;
